import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: '1',
    position: 'absolute',
    top: '-6px',
    right: '-6px',
    cursor: 'pointer'
  },

  tooltip: {
    margin: '20px 0 0 0'
  }
}))

export default useStyles
